import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.TEACHERNAME = function (state, payload) {
  state.teacherName = payload
}
mutations.commission = function (state, payload) {
  state.rows = payload
}
mutations.PAYMENT = function (state, payload) {
  state.paymentDetails = {
    paid: [],
    pending: []
  }
  payload.forEach(element => {
    element.files = {}
    if (element.progress === 0) {
      state.paymentDetails.pending.push(element)
    } else {
      state.paymentDetails.paid.push(element)
    }
  })
}

const state = {
  rows: [],
  row: null,
  condition: {},
  teacherName: [],
  paymentDetails: {}
}
const actions = {
  init: ({ commit, state }, input) => {
    const ctx = {
      data: {
        teacherName: {api: 'M0302CommissionRecordService.getAllTeacherName'},
        paymentDetails: {api: 'M0303CommissionPaymentService.getTableDetails'}
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('TEACHERNAME', data.teacherName.output)
        commit('PAYMENT', data.paymentDetails.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0302CommissionRecord cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0302CommissionRecord search')
    return client.postData({ data: { search: { api: 'M0302CommissionRecordService.searchAllCommissionRecords', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        var approvedRecord = []
        data.search.output.forEach(commissionRow => {
          commissionRow.total_unpaid = 0
          commissionRow.allSelected = 0
          commissionRow.commission_record.forEach(element => {
            if (!element.payment_receipt) {
              commissionRow.total_unpaid += element.commission_amount
            }
          })
          if (commissionRow.total_unpaid > 0) {
            approvedRecord.push(commissionRow)
          }
        })
        commit('commission', approvedRecord)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0302CommissionRecord add')
    commit('EDIT',
      {
        id: null,
        files: {},
        relates: {},
        belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0302CommissionRecord edit')
    return client.postData({ data: { find: { api: 'M0302CommissionRecordService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0302CommissionRecord delete')
    return client.postData({ data: { delete: { api: 'M0302CommissionRecordService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0303CommissionPayment save')
    return client.postData({ data: { save: { api: 'M0303CommissionPaymentService.updatePaymentDetails', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0302CommissionRecord download')
    return client.download({ data: { download: { api: 'M0302CommissionRecordService.downloadData', input: condition } } })
  },
  savePaymentDetails: ({ commit, state }, row) => {
    return client.postData({ data: { save: { api: 'M0302CommissionRecordService.savePaymentDetails', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0302CommissionRecord/M0302CommissionRecordStore.js